module.exports = __webpack_public_path__ + "media/images/patterns/3-c52f89a15d1bd24aaa8ca2290354d60d.png";